import React from 'react';
import withState from '../../../../../../utils/withState';
import {paramStore} from "../../../../../../stores";

import TableDisplay from './TableDisplay';
import NotificationSettings from './NotificationSettings';

const form$ = paramStore('form');
const id$ = paramStore('id');

module.exports = withState(() => {
  return (state) => {

    const emitInnerRoute = ({page, id}) => {
      form$.emit(page);
      id$.emit(id);
    }

    const onBack = () => emitInnerRoute({page: '', id: ''});

    if (!state.form || !state.id) return <TableDisplay emitInnerRoute={emitInnerRoute} />

    if (state.form === 'notifications') return <NotificationSettings id={state.id} onBack={onBack} />

    return <span />
  }
}, {
  form: form$,
  id: id$,
})
